import { nation,nation1 } from "./fieldOptions/dict";
import { getDictOne } from "@/utils/storage";
const CodeList = getDictOne('poli_affi_code');
const CodeList2 = getDictOne('edu_lev_code');
let dictList=[];
let dictList2=[];

CodeList.map((a)=>{
    let obj={}
    obj.value=a.dictKey;
    obj.label=a.dictValue
    dictList.push(obj);
})
CodeList2.map((a)=>{
    let obj={}
    obj.value=a.dictKey;
    obj.label=a.dictValue
    dictList2.push(obj);
})
export const baseInfo = (data = {}) => {
    let mapData = data
    return [
        {
            type: 'text', label: '姓名', name: 'personalName', value: mapData.personalName, placeholder: '请输入姓名',
            rules: [{ required: true, message: '请输入', trigger: 'blur' }]
        },
        {
            type: 'select', label: '政治面貌', name: 'politicalFace', value: mapData.politicalFace, placeholder: '请输入政治面貌',
            // options: [{
            //     value: '1',
            //     label: '党员'
            // }, {
            //     value: '2',
            //     label: '团员'
            // }, {
            //     value: '3',
            //     label: '群众'
            // }]
            options:dictList
        
        },
        {
            type: 'select', label: '性别', name: 'gender', value: mapData.gender, placeholder: '请输入性别', options: [{
                value: '1',
                label: '男'
            }, {
                value: '2',
                label: '女'
            }]
        },
        {
            type: 'date', label: '出生日期', name: 'birthDate', value: mapData.birthDate, placeholder: '请输入出生日期'
        },
        {
            type: 'text', label: '身高', name: 'height', value: mapData.height, placeholder: '请输入身高'
        },
        {
            type: 'area', label: '籍贯', name: 'origin', value: mapData.origin, placeholder: '请输入籍贯', 
            // options: [{
            //     value: '1',
            //     label: '北京'
            // }, {
            //     value: '2',
            //     label: '湖南'
            // }, {
            //     value: '3',
            //     label: '未知'
            // }]
        },
        {
            type:'text',label:'求职岗位',name:'position',value:mapData.position,placeholder:"请输入求职岗位",
        },
        {
            type: 'text', label: '薪资', name: 'salary', value: mapData.salary, placeholder: '请输入薪资'
        },
        {
            type: 'text', label: '电子邮箱', name: 'email', value: mapData.email, placeholder: '请输入电子邮箱'
        },
        {
            type: 'select', label: '民族', name: 'personalGroup', value: mapData.personalGroup, placeholder: '请输入民族', options: nation1
        },
        {
            type: 'text', label: '详细地址', name: 'detailedAddress', value: mapData.detailedAddress, placeholder: '请输入详细地址'
        },
        {
            type: 'text', label: '手机号码', name: 'phone', value: mapData.phone, placeholder: '请输入手机号码'
        },
        {
            type: 'text', label: '现居地址', name: 'currentPlace', value: mapData.currentPlace, placeholder: '请输入现居地址'
        },
        {
            type: 'text', label: '身份证号码', name: 'identityCard', value: mapData.identityCard, placeholder: '请输入身份证号码'
        },
        {
            type: 'select', label: '最高学历', name: 'highestEducation', value: mapData.highestEducation, placeholder: '请输入最高学历', options: [{
                value: '1',
                label: '高中'
            }, {
                value: '2',
                label: '大专'
            }, {
                value: '3',
                label: '本科'
            },
            {
                value:'4',
                label:'研究生'
            }, 
            
            {
                value: '5',
                label: '硕士'
            }, {
                value: '6',
                label: '博士'
            }]
        },
        {
            type: 'text', label: '户口簿地址', name: 'householdAddress', value: mapData.householdAddress, placeholder: '请输入户口簿地址'
        },
        {
            type: 'date', label: '退伍时间', name: 'dischargeTime', value: mapData.dischargeTime, placeholder: '请输入退伍时间'
        },
        {
            type: 'text', label: '特长', name: 'specialty', value: mapData.specialty, placeholder: '请输入特长'
        },
        {
            type: 'text', label: '军龄', name: 'militaryAge', value: mapData.militaryAge, placeholder: '请输入军龄'
        },
        {
            type: 'text', label: '工作年限', name: 'yearsOfService', value: mapData.yearsOfService, placeholder: '请输入工作年限'
        },
        // {
        //     type: 'text', label: '就业单位', name: 'employmentUnits', value: mapData.employmentUnits, placeholder: '请输入就业单位'
        // },
        // {
        //     type: 'text', label: '就业时间', name: 'employmentTime', value: mapData.employmentTime, placeholder: '请输入就业时间'
        // }

    ]
}

export const educateBackground = (data = {}) => {
    console.log('CodeList2CodeList2',dictList2);
    
    return [
        {
            type: 'text', label: '毕业院校', name: 'school', value: data.school, placeholder: '请输入毕业院校'
        },
        {
            type: 'text', label: '专业', name: 'qualifications', value: data.qualifications, placeholder: '请输入专业'
        },
        {
            type: 'select', label: '学历', name: 'degree', value: data.degree, placeholder: '请输入学历',options:dictList2
        },
        {
            type: 'start_stop_time', label: '起止时间', name: 'startEndTimes', value: data.startEndTimes, placeholder: '请输入起止时间'
        }
    ]
}


export const workExperience = (data = {}) => {
    return [
        {
            type: 'text', label: '公司名称', name: 'unitName', value: data.unitName, placeholder: '请输入公司名称'
        },
        {
            type: 'text', label: '职位名称', name: 'positionName', value: data.positionName, placeholder: '请输入职位名称'
        },
        {
            type: 'start_stop_time', label: '起止时间', name: 'startEndTimes', value: data.startEndTimes, placeholder: '请输入起止时间'
        },
        {
            type: 'text', label: '工作描述', name: 'jobContent', value: data.jobContent, placeholder: '请输入工作描述'
        }
    ]
}

export const oneselfEvaluation = (data = {}) => {
    return [
        {
            type: 'text', label: '技术', name: 'skills', value: data.skills, placeholder: '请输入技术'
        },
        {
            type: 'text', label: '语言', name: 'language', value: data.language, placeholder: '请输入语言'
        },
        {
            type: 'text', label: '爱好', name: 'hobby', value: data.hobby, placeholder: '请输入爱好'
        }
    ]
}

// rules: {
            //     oldPassword: [
            //         { required: true, message: '请输入旧密码', trigger: 'blur' },
            //         {
            //             validator: (rule, value, callback) => {
            //                 if (value === '') {
            //                     callback(new Error('请输入旧密码'));
            //                 } else {
            //                     callback();
            //                 }
            //             }
            //         }
            //     ],
            // }